import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ColumnHeader } from 'src/app/models/column-header';
import { SrcPath } from 'src/app/constants/srcPath';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { isBlank, isData, setTableName, iconListOptions, iconStyleOptions, popupWidthClassOptions, isPresent } from 'src/app/utils/utils';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Labels } from 'src/app/constants/labels';
import { KEYS } from 'src/app/constants/keys';
import { CommonModule, DatePipe } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { SharedModule } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-create-dashboard',
  templateUrl: './create-dashboard.component.html',
  styleUrls: ['./create-dashboard.component.scss'],
  imports: [CommonModule, NgSelectComponent, ReactiveFormsModule, SharedModule]
})
export class CreateDashboardComponent implements OnInit {

  createDashboardForm: FormGroup | any;
  srcPath = SrcPath;
  labelMessages = Labels.messages;
  labelName = Labels.labels;
  labelPage = Labels.page;
  headerData: ColumnHeader | any;
  appPageList: any = [];
  iconListOption = iconListOptions;
  iconStyleOption = iconStyleOptions;
  popupWidthClassOption = popupWidthClassOptions
  submitted = false;
  dataBeforeEdit = [];
  isSuperaDmin: boolean = false;
  dbPath: any;
  appTemplateList: any = [];
  menuListdata: any = [];
  customerId: string | any;
  Dashboardtype: any = [
    { "id": 1, "name": "Module" },
    { "id": 2, "name": "Page" }
  ];
  pageListData: any = [];
  menumoduleorderData: any;
  staticPageslist!: any[];
  parentMenus: any;
  messageLabel = Labels.messages;
  constructor(private formBuilder: FormBuilder,
    private commonService: CommonService,
    private router: Router,
    private toastr: ToastrService, private route: ActivatedRoute,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.customerId = (this.commonService.getUserCredentials(KEYS.credential_customer_id));
    this.isSuperAdmin();
    this.submitted = false;
    this.loadTemplateList();
    // this.LoadMenu();
    //this.getPageListData();
    this.initPageForm();
    this.loadPageList();
    this.route.queryParams.subscribe(params => {
      const id = params['Id'];
      this.initColumnHeader(params['Id']);
      if (id > 0) {
        const details = params['Details'];
        if (details != null) {
          this.loadPage(JSON.parse(details));
        }
      }
      else {
        this.initColumnHeader(this.createDashboardForm.value.pageId);
        this.initPageForm();
      }
    });

  }
  isSuperAdmin() {
    const sessionSuperAdmin = sessionStorage.getItem(KEYS.isSuperAdmin);
    if (sessionSuperAdmin)
      this.isSuperaDmin = JSON.parse(sessionSuperAdmin);
    if (this.isSuperaDmin) {
      const sessionCustomerPath = sessionStorage.getItem(KEYS.customerDbPath);
      if (sessionCustomerPath)
        this.dbPath = JSON.parse(sessionCustomerPath);
    }
  }
  private initColumnHeader(pageID: any) {
    this.headerData = {
      title: this.labelPage.create_page,
      button: {
        show: false
      },
      topButton: {
        show: true,
        property: [
          {
            title: this.labelMessages.page_creation.page_save,
            icon: SrcPath.saveIcon,
            class: this.labelMessages.page_creation.page_class_back09
          },
          {
            title: this.labelMessages.page_creation.page_back,
            icon: SrcPath.previousIcon,
            class: this.labelMessages.page_creation.page_class_back11
          },
          {
            title: this.labelMessages.page_creation.page_audit,
            icon: SrcPath.auditTrailIcon,
            class: this.labelMessages.page_creation.page_class_back11,
            pageId: pageID,
            fromPage: 1
          }
        ]
      }
    };
  }

  initPageForm() {
    this.createDashboardForm = this.formBuilder.group({
      dashboardId: 0,
      templateId: [null, Validators.required],
      moduleId: [null],
      DashBoardid: [null, Validators.required],
      pageId: [null],
    });
  }

  loadPage(details: any) {
    this.commonService.ogLog('gstibodashboard', details);
    this.createDashboardForm.controls.dashboardId.setValue(details['gstibo_dashboard_id']);
    this.createDashboardForm.controls.templateId.setValue(details['gstibo_template_id']);

    this.createDashboardForm.controls.DashBoardid.setValue(details['gstibo_dashboard_type']);
    if (details['gstibo_dashboard_type'] == 2)
      this.getPageListData();
    else {
      this.LoadMenu();
      this.createDashboardForm.controls.DashBoardid.setValue(1);
    }
    this.createDashboardForm.controls.pageId.setValue(details['gstibo_module_id']);
    this.createDashboardForm.controls.moduleId.setValue(details['gstibo_module_id']);
    // this.createDashboardForm = this.formBuilder.group({
    //   dashboardId: details['gstibo_dashboard_id'],
    //   templateId: [details['gstibo_template_id'], Validators.required],
    //   moduleId: [details['gstibo_module_id'], Validators.required],
    //   DashBoardid: [details['gstibo_dashboard_type'], Validators.required],
    //   pageId: [details['gstibo_module_id'], Validators.required]
    // });
  }

  onSubmit() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.submitted = true;
    let inputLabel = '';
    let pageId = 0, ipaddress = '', machinename = '';
    let moduleid = 0;
    if (this.createDashboardForm.value.DashBoardid == 1)
      moduleid = this.createDashboardForm.value.moduleId;
    else
      moduleid = this.createDashboardForm.value.pageId;
    this.commonService.ogLog('this.createPage.valid:', this.createDashboardForm.valid);
    if (this.createDashboardForm.valid) {
      // if (this.createDashboardForm.value.dashboardId <= 0) {
      this.commonService.createDashboard(
        dbFullPath,
        this.createDashboardForm.value.templateId,
        moduleid,
        this.createDashboardForm.value.dashboardId,
        this.commonService.getUserCredentials(KEYS.credential_customer_id), this.createDashboardForm.value.DashBoardid
      ).subscribe((mdata: any) => {
        if (isData(mdata)) {
          this.createDashboardForm.patchValue({
            dashboardId: mdata['table'][0].id
          });
          if (isPresent(mdata['table'][0].id) && (mdata['table'][0].id) > 0 && mdata['table'][0].valid == '') {
           // this.toastr.success(this.labelMessages.save_success_msg.message);
           this.commonService.showModalValidate(this.labelMessages.save_success_msg.message,'',this.messageLabel.static_messages.info,this.labelMessages.save_success_msg.message);
          }
          else if (mdata['table'][0].valid == 'exists') {
           // this.toastr.warning('Module already exists');
           this.commonService.showModalValidate('Module already exists.','',this.messageLabel.static_messages.warning,'Module already exists.');
          }
          /*  let islinkedafter = (this.createDashboardForm.value.isPagelinked == '0' ? 'false' : 'true');
            let islinkedStatic = (this.createDashboardForm.value.isStaticPagelinked == '0' ? 'false' : 'true');
            inputLabel = "Page Name" + " ~~ " + this.createDashboardForm.value.pageName + "~~~" +
              "Description " + " ~~ " + this.createDashboardForm.value.pageDesc + "~~~" +
              "Icon " + " ~~ " + this.createDashboardForm.value.pageIcon + "~~~" +
              "BG Color " + " ~~ " + this.createDashboardForm.value.pageBgColor + "~~~" +
              "Icon Style " + " ~~ " + (this.createDashboardForm.value.pageIconStyle == null ? '' : this.createDashboardForm.value.pageIconStyle) + "~~~" +
              "Link Page " + " ~~ " + this.createDashboardForm.value.isPagelinked + "~~~" +
              "Link Page Id " + " ~~ " + this.createDashboardForm.value.linkPageId + "~~~" +
              "Show Static Data " + " ~~ " + this.createDashboardForm.value.isStaticPagelinked + "~~~" +
              "Static Page Id " + " ~~ " + this.createDashboardForm.value.staticPageId + "~~~" +
              "Created By" + " ~~ " + this.commonService.getUserCredentials(KEYS.credential_account_id) + "~~~" +
              "Created On" + " ~~ " + this.datePipe.transform(new Date(), 'MM-dd-yyyy');
            this.commonService.saveAuditTrialAdmin(dbFullPath, pageId, 0, 0, KEYS.saveType.INSERT, ipaddress, machinename,
              this.commonService.getUserCredentials(KEYS.credential_customer_id), inputLabel,
              this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(auditdata => {
              },
                error => {
                  this.commonService.ogLog('generateAuditTrail Error:', error);
                });*/
          //this.initColumnHeader(this.createDashboardForm.value.dashboardId);
        }

      });

      // } 
      /*else {
        this.commonService.updatePage(
          dbFullPath,
          this.createDashboardForm.value.pageId,
          this.createDashboardForm.value.pageName,
          this.createDashboardForm.value.pageDesc,
          this.createDashboardForm.value.pageIcon,
          this.createDashboardForm.value.pageBgColor,
          (this.createDashboardForm.value.pageIconStyle == null ? '' : this.createDashboardForm.value.pageIconStyle),
          this.commonService.getUserCredentials(KEYS.credential_customer_id),
          (this.createDashboardForm.value.isPagelinked == KEYS.checkedStatus.checked ? (this.createDashboardForm.value.linkPageId == null ? KEYS.checkedStatus.unchecked : this.createDashboardForm.value.linkPageId) : KEYS.checkedStatus.unchecked),
          (this.createDashboardForm.value.isStaticPagelinked == KEYS.checkedStatus.checked ? (this.createDashboardForm.value.staticPageId == null ? KEYS.checkedStatus.unchecked : this.createDashboardForm.value.staticPageId) : KEYS.checkedStatus.unchecked),
          this.createDashboardForm.value.popupWidthClass
        ).subscribe((data :any)=> {
          this.toastr.success(this.labelMessages.update_success_msg.message);
          let updatedDetails = [];
          this.commonService.loadPageDetailsById(dbFullPath, this.createDashboardForm.value.pageId).subscribe(adata => {
            isData(adata)
            {
              updatedDetails = adata['table'][0];
              this.dataBeforeEdit = JSON.parse(sessionStorage.getItem(KEYS.pageDetailsEdit));
              if (updatedDetails != null && this.dataBeforeEdit != null) {
                if (updatedDetails['gstibo_page_name'] != this.dataBeforeEdit['gstibo_page_name']) {
                  inputLabel += "Page Name" + " ~~ " + updatedDetails['gstibo_page_name'] + " ~ " + this.dataBeforeEdit['gstibo_page_name'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_app_description'] != this.dataBeforeEdit['gstibo_app_description']) {
                  inputLabel += "Description" + " ~~ " + updatedDetails['gstibo_app_description'] + " ~ " + this.dataBeforeEdit['gstibo_app_description'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_icon'] != this.dataBeforeEdit['gstibo_icon']) {
                  inputLabel += "Icon" + " ~~ " + updatedDetails['gstibo_icon'] + " ~ " + this.dataBeforeEdit['gstibo_icon'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_bg_color'] != this.dataBeforeEdit['gstibo_bg_color']) {
                  inputLabel += "BG Color" + " ~~ " + updatedDetails['gstibo_bg_color'] + " ~ " + this.dataBeforeEdit['gstibo_bg_color'] + " " + "~~~";
                }
                if (updatedDetails['gstibo_menu_style'] != this.dataBeforeEdit['gstibo_menu_style']) {
                  inputLabel += "Icon Style" + " ~~ " + updatedDetails['gstibo_menu_style'] + " ~ " + this.dataBeforeEdit['gstibo_menu_style'] + " " + "~~~";
                }
                let islinkedafter = (updatedDetails['gstibo_linked_page'] == '0' ? 'false' : 'true');
                let islinkedbefore = (this.dataBeforeEdit['gstibo_linked_page'] == '0' ? 'false' : 'true');
                if (updatedDetails['gstibo_linked_page'] != this.dataBeforeEdit['gstibo_linked_page']) {
                  inputLabel += "Link Page" + " ~~ " + islinkedafter + " ~ " + islinkedbefore + " " + "~~~";
                }
                if (updatedDetails['linked_page_name'] != this.dataBeforeEdit['linked_page_name']) {
                  inputLabel += "Linked Page Name" + " ~~ " + updatedDetails['linked_page_name'] + " ~ " + this.dataBeforeEdit['linked_page_name'] + " " + "~~~";
                }
                let islinkedafterstatic = (updatedDetails['gstibo_linked_page_static'] == '0' ? 'false' : 'true');
                let islinkedbeforestatic = (this.dataBeforeEdit['gstibo_linked_page_static'] == '0' ? 'false' : 'true');
                if (updatedDetails['gstibo_linked_page_static'] != this.dataBeforeEdit['gstibo_linked_page_static']) {
                  inputLabel += "Show Static Data" + " ~~ " + islinkedafterstatic + " ~ " + islinkedbeforestatic + " " + "~~~";
                }
                if (updatedDetails['linked_page_static_name'] != this.dataBeforeEdit['linked_page_static_name']) {
                  inputLabel += "Static Page Name" + " ~~ " + updatedDetails['linked_page_static_name'] + " ~ " + this.dataBeforeEdit['linked_page_static_name'] + " " + "~~~";
                }
                inputLabel += "Updated By" + " ~~ " + this.commonService.getUserCredentials(KEYS.credential_account_id) + "~~~" +
                  "Updated On" + " ~~ " + this.datePipe.transform(new Date(), 'MM-dd-yyyy');
                this.commonService.saveAuditTrialAdmin(dbFullPath, this.createDashboardForm.value.pageId, 0, 0, KEYS.saveType.UPDATE, ipaddress, machinename,
                  this.commonService.getUserCredentials(KEYS.credential_customer_id), inputLabel,
                  this.commonService.getUserCredentials(KEYS.credential_account_id)).subscribe(auditdata => {
                  },
                    error => {
                      this.commonService.ogLog('generateAuditTrail Error:', error);
                    });
              }
            }
          });
        });
       
      }*/
    }
    else {
      if (isBlank(this.createDashboardForm.value.pageName)) {
       // this.toastr.warning("Please fill the mandatory fields.");
       this.commonService.showModalValidate('Please fill the mandatory fields.','',this.messageLabel.static_messages.warning,'Please fill the mandatory fields.');
      }
    }
  }
  loadPageList() {
    this.appPageList = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadPageList(dbFullPath).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      if (isData(data)) {
        data['table'].forEach((element: any) => {
          this.appPageList.push({
            'pageId': element.gstibo_page_id,
            'pageName': element.gstibo_page_name
          });
        });
      }
    });
  }
  loadTemplateList() {
    this.appTemplateList = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadTemplateList(dbFullPath).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      if (isData(data)) {
        data['table'].forEach((element: any) => {
          this.appTemplateList.push({
            'templateId': element.gstibo_template_id,
            'templateName': element.gstibo_template_name
          });
        });
      }
    });
  }
  LoadMenu() {
    this.menuListdata = [];
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadMenu(dbFullPath, this.customerId).subscribe((data: any) => {
      if (isData(data)) {
        this.menuListdata = data['table'].filter((x: any) => x.gstibo_parent_menu_id == 0);
        // this.menuChildListdata = data['table'].filter((x: any)=> x.gstibo_parent_menu_id == this.menuParentId);
        this.parentMenus = this.menuListdata;
        const parentmenus = this.staticPageslist.filter((x: any) => x.gstibo_is_show_parentmodule_Id == 0);
        parentmenus.forEach((element: any) => {
          this.menuListdata.push(
            {
              'gstibo_menu_name': element.gstibo_menu_name,
              'gstibo_menu_id': element.gstibo_menu_id,
              'moduleid': element.gstibo_menu_id,
              'gstibo_menu_icon': 'timesheet',
              'pgid': element.gstibo_page_id,
              'child': data['table'].filter((x: any) => (x.gstibo_parent_menu_id == element.gstibo_menu_id ||
                x.parent == element.gstibo_menu_id) && x.gstibo_menu_type == 1 && x.parent_menu_id == 0),
              'pagetype': 'S'
            });

        });
        this.commonService.ogLog("menuListdata", this.menuListdata);

      } else {
        this.commonService.ogLog('data not available');
      }
    },
      error => {
        console.log('executeLogicAppsApi Error:', error);
      });
  }

  get f() { return this.createDashboardForm.controls; }
  getPageListData() {
    let dbFullPath = this.isSuperaDmin == true ? this.dbPath : '';
    this.commonService.loadPageList(dbFullPath).subscribe((data: any) => {
      this.commonService.ogLog('data : ', data['table']);
      this.pageListData = data['table'];

    });
  }
  Bindmodulepage() {
    if (this.createDashboardForm.controls.DashBoardid.value == 1) {
      this.createDashboardForm.controls.moduleId.setValidators(Validators.required);
      this.createDashboardForm.controls.pageId.clearValidators();

      this.LoadMenu();
    }
    else {
      this.createDashboardForm.controls.moduleId.clearValidators();
      this.createDashboardForm.controls.pageId.setValidators(Validators.required);
      this.getPageListData();
    }
  }

}
